/* YOUNGER — 關於我們 v2：reveal + 數字 count-up + 顧問分頁（本頁未載 bd-home.js，自帶）*/
(function(){
  function boot(){
    // reveal
    var rv = document.querySelectorAll('.abx .reveal');
    if(rv.length){
      if('IntersectionObserver' in window){
        var ro=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');ro.unobserve(e.target);}});},{threshold:0.12,rootMargin:'0px 0px -6% 0px'});
        rv.forEach(function(el){ro.observe(el);});
      } else { rv.forEach(function(el){el.classList.add('in');}); }
    }
    // count-up
    function countUp(el){
      var target=parseInt(el.getAttribute('data-count'),10)||0, dur=1400, t0=performance.now();
      (function tick(now){
        var p=Math.min((now-t0)/dur,1), e=1-Math.pow(1-p,3);
        el.textContent=Math.round(target*e).toLocaleString('en-US');
        if(p<1) requestAnimationFrame(tick); else el.textContent=target.toLocaleString('en-US');
      })(performance.now());
    }
    var nums=document.querySelectorAll('.abx .tv-num[data-count]');
    if(nums.length && 'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){countUp(e.target);io.unobserve(e.target);}});},{threshold:0.6});
      nums.forEach(function(el){io.observe(el);});
    } else { nums.forEach(countUp); }
    // advisors tabs + 手機抽屜
    var root=document.querySelector('.abx .ab-pcat-adv');
    if(root){
      var advBox=root.querySelector('.ab-adv');
      var items=root.querySelectorAll('.ab-adv-item'), panels=root.querySelectorAll('.ab-adv-panel');
      root.addEventListener('click',function(e){
        if(e.target.closest('[data-adv-close]')){ if(advBox) advBox.classList.remove('is-open'); return; }
        var btn=e.target.closest('.ab-adv-item'); if(!btn) return;
        var id=btn.getAttribute('data-adv');
        items.forEach(function(i){i.classList.toggle('is-active',i===btn);});
        panels.forEach(function(p){p.classList.toggle('is-active',p.getAttribute('data-adv')===id);});
        if(advBox) advBox.classList.add('is-open');   // 手機版滑出簡介；桌機無此樣式、不受影響
      });
    }
    // 三種服務：膠囊 <-> 橫向捲動卡片 + 自動輪播
    // （scrollspy 用 scroll 事件，不用 IntersectionObserver —— 內嵌預覽不觸發 IO）
    document.querySelectorAll('[data-abmodes]').forEach(function(box){
      var tabs=box.querySelectorAll('.ab-mtab');
      var row=box.querySelector('[data-mrow]'); if(!row) return;
      var cards=row.querySelectorAll('.ab-mcard'); if(!cards.length) return;

      var AUTO_MS=4600, idx=0, timer=null;
      var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

      function setActive(i){
        tabs.forEach(function(t){t.classList.toggle('is-active',t.getAttribute('data-mtab')===String(i));});
      }
      function goTo(i){
        idx=(i%cards.length+cards.length)%cards.length;
        setActive(idx);
        row.scrollTo({left:cards[idx].offsetLeft-row.offsetLeft,behavior:'smooth'});
      }
      function stop(){ if(timer){clearInterval(timer);timer=null;} }
      var inView=false;                                        // 進畫面才自動輪播
      function start(){
        if(!inView||reduce||cards.length<2||timer) return;     // 未進畫面／減少動態：不啟動
        timer=setInterval(function(){ goTo(idx+1); },AUTO_MS); // 循環：末張回到第一張
      }
      function bump(){ stop(); start(); }                      // 使用者操作後重新計時

      // 點膠囊：捲到該卡並重新計時
      box.addEventListener('click',function(e){
        var b=e.target.closest('.ab-mtab'); if(!b) return;
        goTo(parseInt(b.getAttribute('data-mtab'),10));
        bump();
      });

      // 捲動 -> 同步膠囊（同時更新 idx，讓自動輪播接著使用者停的位置繼續）
      // 注意：這裡刻意不呼叫 bump()，否則自動捲動自己觸發的 scroll 會不斷重設計時器
      var tick;
      row.addEventListener('scroll',function(){
        clearTimeout(tick);
        tick=setTimeout(function(){
          var best=0,min=Infinity;
          cards.forEach(function(c,i){
            var d=Math.abs((c.offsetLeft-row.offsetLeft)-row.scrollLeft);
            if(d<min){min=d;best=i;}
          });
          idx=best; setActive(best);
        },60);
      },{passive:true});

      // 暫停條件：滑鼠停留、手指操作中、分頁切走
      box.addEventListener('mouseenter',stop);
      box.addEventListener('mouseleave',start);
      row.addEventListener('touchstart',stop,{passive:true});
      row.addEventListener('touchend',function(){ setTimeout(start,3000); },{passive:true});
      document.addEventListener('visibilitychange',function(){ document.hidden?stop():start(); });

      // 進畫面才開始自動輪播：用捲動事件判斷（與 scrollspy 同慣例，不用 IntersectionObserver）
      function isInView(){
        var r=box.getBoundingClientRect();
        var vh=window.innerHeight||document.documentElement.clientHeight;
        return r.top < vh*0.85 && r.bottom > vh*0.15;          // 區塊有實質露出即算進畫面
      }
      var rafPend=false;
      function syncView(){
        rafPend=false;
        var now=isInView();
        if(now&&!inView){ inView=true; start(); }
        else if(!now&&inView){ inView=false; stop(); }
      }
      function onScroll(){ if(!rafPend){ rafPend=true; requestAnimationFrame(syncView); } }
      window.addEventListener('scroll',onScroll,{passive:true});
      window.addEventListener('resize',onScroll);
      syncView();                                              // 初次判斷（進站時多半在摺線下→不啟動）
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
